module.exports = __webpack_public_path__ + "static/fear-f3566f8c0a9a6bb762aa869e907cef1e.svg";